<div class="border pad15 mb15 position-relative">
  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <div class="fixed-table-container resp-table">
          <div class="comnt-container">
            <h4 class="title16 mb15 d-flex align-items-center"><span translate>lblComments</span> <strong class="badge bg-dark ml-3 text-white vm">{{commentsLenght}}</strong> </h4>
            <div *ngIf="response && response.length > 0" class="comment-header-text">
              <div class="comment-raw d-flex border-bottom align-items-center mb-3 w-100" *ngFor="let data of response">
                <div class="left-comment-ico mr-2 p-3" *ngIf="data.isCustomerComment">
                  <img src="/assets/images/Customer_comment_Outline.png"
                    onError="this.onerror=null; this.src='../../../../../../../../assets/images/no-image-icon.png'"
                    class="image" width="30" alt="">
                </div>
                <div class="left-comment-ico mr-2 p-3" *ngIf="!data.isCustomerComment">
                  <img src="/assets/images/Mechanic_comment_Outline.png"
                    onError="this.onerror=null; this.src='../../../../../../../../assets/images/no-image-icon.png'"
                    class="image" width="30" alt="">
                </div>
                <div class="comment-details flex-grow-1">
                  
                  <div class="d-flex align-items-center mb-1">
                    <div class="comment-title" *ngIf="data.user !== null">
                      {{data.user}}
                    </div>
                    <div class="comment-date text-muted ml-3 font11">
                      {{ data.updatedDate | date:'short'}}
                    </div>
                  </div>
                  
                  
                  <p class="comment-data">{{data.comment ?
                    data.comment : ''}}</p>
                </div>
              </div>
            </div>
            <div class="comment-raw no-record" *ngIf="!response || response.length === 0">
              {{'lblNoRecordsFound' | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>